import { IconPencil } from '@tabler/icons-react';
import classNames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { NSCard, NSButton } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';

import './UsesCard.scss';

 
const LOCKED_TOOLTIP_COPY = 'This card is read only. Apply edits in table view once more than one budget line has been added for any of the cards';

interface Props {
    id: string;
    title: string;
    total: number | null | undefined;
    costPerUnit: number | null | undefined;
    unitLabel: string;
    supplemental?: string;
    isLocked: boolean;
    isLastCard?: boolean;
    onEnterEdit?: () => void;
}

const UsesCard = ({
    id,
    title,
    total,
    costPerUnit,
    unitLabel,
    supplemental,
    isLocked,
    isLastCard = false,
    onEnterEdit,
}: Props) => (
    <NSCard
        id={id}
        className={classNames('UsesCard NSCard--level-5 d-flex flex-column rounded-lg p-3', { 'mr-3': !isLastCard })}
    >
        <div className="d-flex align-items-start justify-content-between mb-1">
            <div className="d-flex flex-column">
                <div className="text-dark mb-2">{title}</div>
                <div className="text-dark font-24 font-weight-semibold">
                    {total != null && !Number.isNaN(total) ? numeralFormatterCurrency(total, '$0,0') : '—'}
                </div>
            </div>
            <RenderIf isTrue={!isLocked}>
                <NSButton
                    icon={IconPencil}
                    size="sm"
                    ariaLabel={`Edit ${title}`}
                    className="p-0"
                    callback={onEnterEdit}
                />
            </RenderIf>
        </div>
        <div className="font-12">
            <span>{costPerUnit != null && !Number.isNaN(costPerUnit) ? `${numeralFormatterCurrency(costPerUnit)} / ${unitLabel}` : '—'}</span>
            <RenderIf isTrue={Boolean(supplemental)}>
                <span> · {supplemental}</span>
            </RenderIf>
        </div>
        <RenderIf isTrue={isLocked}>
            <UncontrolledTooltip
                target={id}
                placement="top"
                container="body"
                boundariesElement="window"
                positionFixed
            >
                {LOCKED_TOOLTIP_COPY}
            </UncontrolledTooltip>
        </RenderIf>
    </NSCard>
);

export default UsesCard;
